module.exports = __webpack_public_path__ + "img/6.f03395a8.png";